/**
 * Настройки приватности (cookies / сбор данных).
 * Сохраняются в localStorage в SettingsPrivacy, здесь только чтение для использования по приложению.
 */

export const PRIVACY_STORAGE_KEY = 'astromatch_privacy_cookies'

export const DEFAULT_PRIVACY = {
  essential: true,
  functional: true,
  performance: true,
  advertising: true
}

/**
 * Возвращает текущие настройки приватности из localStorage.
 * Используется перед отправкой аналитики и в Sentry при инициализации.
 */
export function getPrivacyPreferences() {
  try {
    const raw = localStorage.getItem(PRIVACY_STORAGE_KEY)
    if (!raw) return { ...DEFAULT_PRIVACY }
    const parsed = JSON.parse(raw)
    return { ...DEFAULT_PRIVACY, ...parsed }
  } catch {
    return { ...DEFAULT_PRIVACY }
  }
}

/**
 * Можно ли отправлять аналитику использования (Performance cookies).
 */
export function isPerformanceAllowed() {
  return getPrivacyPreferences().performance === true
}

/**
 * Можно ли отправлять рекламные события (Advertising cookies).
 */
export function isAdvertisingAllowed() {
  return getPrivacyPreferences().advertising === true
}
